<script>
	import { getContext } from 'svelte'
	import { lighten } from '../../utils'

	export let t
	export let colors

	const isMobile = getContext('isMobile')

	const legendSecondary = [
		{
			label: t('moderately damaged'),
			labelMobile: t('moderately'),
			color: colors.primary
		},
		{
			label: t('significantly damaged'),
			labelMobile: t('significantly'),
			color: colors.secondary
		},
		{
			label: t('severely damaged'),
			labelMobile: t('severely'),
			color: colors.tertiary
		}
	]
</script>

<div class="legend">
	<div class="legend__section">
		<div class="legend__subsection">
			{#each legendSecondary as { label, labelMobile, color }}
				<div class="legend__item">
					<div
						class="legend__item__color-swatch"
						style:--background-color={lighten(color, 0.5)}
						style:--border-color={color}
					/>
					<div class="legend__item__label">
						{label}
						<!--{$isMobile && labelMobile ? labelMobile : label}-->
					</div>
				</div>
			{/each}
		</div>
	</div>
</div>

<style lang="scss">
	.legend {
		display: flex;
		justify-content: space-between;
		// justify-content: space-evenly;
		align-items: center;
		gap: 30px;
		//margin-top: 10px;
		max-width: 500px;
		//margin-left: auto;
		//margin-right: auto;

		@media (max-width: $breakpoint-mobile-m) {
			flex-direction: column;
			align-items: center;
			gap: 10px;
			max-width: unset;
		}

		&__subsection {
			display: flex;
			justify-content: space-between;
			gap: 20px;
			position: relative;
			//padding: 0 10px;
			align-items: baseline;

			@media (max-width: $breakpoint-mobile-m) {
				justify-content: space-around;
			}
		}

		&__item {
			text-align: center;
			display: flex;
			//flex-direction: column-reverse;
			justify-content: center;
			align-items: center;
			//min-height: 90px;

			@media (max-width: $breakpoint-mobile-m) {
				//flex-direction: column;
				min-height: auto;
			}

			&__label {
				opacity: 0.9;
				font-size: 14px;

				&.nobr {
					white-space: nowrap;
				}
			}

			&__color-swatch {
				position: relative;
				content: '';
				width: 14px;
				height: 14px;
				flex: 0 0 14px;
				border-radius: 50px;
				background-color: var(--background-color);
				border: 1px solid var(--border-color);
				margin-right: 5px;
				// opacity: 0.65;
				// margin-top: -1px;
				// z-index: -1;
				//@media (max-width: $breakpoint-mobile-m) {
				//	margin-top: 5px;
				//}
			}

			/* FIXME: no effect; opacity is inherited */
			// &__color-swatch::before {
			// 	content: '';
			// 	position: absolute;
			// 	top: -1px;
			// 	left: -1px;
			// 	width: 15px;
			// 	height: 15px;
			// 	border-radius: 50px;
			// 	border: 1px solid var(--background-color);
			// 	opacity: 1;
			// 	z-index: 1;
			// }
		}
	}
</style>
